"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.revisionTouchedIds = revisionTouchedIds;
const revision_diff_js_1 = require("./revision-diff.js");
function revisionTouchedIds(raw) {
    const meta = (0, revision_diff_js_1.normalizeRevisionV2Metadata)(raw);
    const deletedMilestoneIds = meta.milestonesDeleted.map((item) => item.id);
    const milestoneIds = [
        ...new Set([
            ...meta.milestoneChanges.map((item) => item.id),
            ...meta.milestonesAdded.map((item) => item.tempId),
            ...deletedMilestoneIds,
            ...meta.submilestoneChanges.map((item) => item.id),
            ...meta.submilestonesAdded.map((item) => item.tempId),
            ...meta.submilestonesDeleted.map((item) => item.id),
            ...meta.invoiceChanges.flatMap((change) => change.milestoneIds ?? []),
        ]),
    ];
    return {
        milestoneIds,
        deletedMilestoneIds,
        adjustmentIds: [...meta.adjustmentIds],
    };
}
